import React from 'react';

import { SkeletonBody, SkeletonProfileImage } from '@xingternal/skeleton';

import { useBreakpoints } from '@/hooks';

import * as S from './skeleton.styles';

type Props = {
  className?: string;
};

export const JobTeaserCardSkeleton: React.FC<Props> = ({ className }) => (
  <article className={className}>
    <S.Container>
      <S.Header>
        <SkeletonProfileImage />
        <S.Date amountRows={1} />
      </S.Header>
      <S.Body amountRows={5} />
    </S.Container>
  </article>
);

export const JobTeaserListSkeleton: React.FC<Props> = ({ className }) => {
  const { isMobile } = useBreakpoints();

  return (
    <article className={className}>
      <S.ListItemContainer data-testid="job-teaser-list-skeleton">
        <S.Image size={isMobile ? 'medium' : 'large'} />
        <S.ListItemText>
          {isMobile ? (
            <>
              <S.Date amountRows={1} />
              <S.Body amountRows={4} />
            </>
          ) : (
            <>
              <S.Title amountRows={2} size="small" />
              <S.Rating amountRows={2} />
              <SkeletonBody amountRows={2} />
            </>
          )}
        </S.ListItemText>
        {isMobile ? null : <S.Button size="small" />}
      </S.ListItemContainer>
    </article>
  );
};
